import { AIRPORTS } from '../data/airports';
import type { Airport } from './types';

/**
 * 联机开局城市清单：只列出条件与香港相当的大型枢纽
 * （市场规模 9 以上），避免玩家盲选到需求过低的城市而无法起步。
 * 客户端大厅 UI 与服务端校验共用同一份清单。
 */

export const STARTING_CITY_MIN_MARKET = 9;

export function listStartingCities(): Airport[] {
  return AIRPORTS
    .filter((airport) => airport.market >= STARTING_CITY_MIN_MARKET)
    .sort((a, b) => b.market - a.market || b.business + b.tourism - (a.business + a.tourism) || a.iata.localeCompare(b.iata));
}

export function isStartingCity(iata: string): boolean {
  return AIRPORTS.some((airport) => airport.iata === iata && airport.market >= STARTING_CITY_MIN_MARKET);
}
